import React from "react";
import { Box, Button, Typography, useTheme, Zoom } from "@mui/material";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../BackgroundWrapper";
import { useAppSelector } from "../../store";
import { getAreOpenedRegistrations } from "../../features/tournoi/tournoiSlice";
import HomeClosed from "./HomeClosed";

const Home: React.FC = () => {
  const theme = useTheme();
  const areOpenedRegistrations = useAppSelector(getAreOpenedRegistrations);
  const tournoi = useAppSelector((state) => state.tournoi.tournoi);
  const isAdmin = useAppSelector((state) => state.session.admin);

  // Logs de debug pour vérifier la logique
  console.log("🏠 [DEBUG] Home - État actuel:");
  console.log("🏠 [DEBUG] - isAdmin:", isAdmin);
  console.log(
    "🏠 [DEBUG] - tournoi:",
    tournoi
      ? {
          isRegisterClosed: tournoi.isRegisterClosed,
          isRegisterClosedAdmin: tournoi.isRegisterClosedAdmin,
        }
      : "null"
  );
  console.log("🏠 [DEBUG] - areOpenedRegistrations:", areOpenedRegistrations);

  // Si les inscriptions sont fermées, afficher la page HomeClosed
  if (!areOpenedRegistrations) {
    console.log("🏠 [DEBUG] Home - Affichage de HomeClosed");
    return <HomeClosed />;
  }

  console.log("🏠 [DEBUG] Home - Affichage de Home normale");

  return (
    <BackgroundWrapper>
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          maxWidth: 900,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Zoom in>
          <Box sx={{ textAlign: "center", mb: 4, px: 1 }}>
            <Typography
              variant="h4"
              fontWeight={700}
              gutterBottom
              sx={{
                color: theme.palette.primary.main,
                fontSize: { xs: "1.8rem", sm: "2.2rem" },
              }}
            >
              Tournoi National SQY Ping 2025
            </Typography>
            <Typography
              variant="h6"
              fontWeight={600}
              sx={{ fontSize: { xs: "1.1rem", sm: "1.3rem" } }}
            >
              28 et 29 juin - Gymnase Alain Mimoun, Villepreux (78)
            </Typography>
          </Box>
        </Zoom>

        <Zoom in>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
              mb: 4,
              flexWrap: "wrap",
            }}
          >
            <Button
              component={Link}
              to="/register"
              variant="contained"
              color="primary"
              size="large"
              sx={{ fontWeight: 600, px: 4, width: { xs: "100%", sm: "auto" } }}
            >
              Je m'inscris maintenant
            </Button>

            <Button
              component={Link}
              to="/boards"
              variant="outlined"
              color="primary"
              size="large"
              sx={{ fontWeight: 600, px: 4, width: { xs: "100%", sm: "auto" } }}
            >
              Voir les tableaux
            </Button>
          </Box>
        </Zoom>

        <Box
          sx={{
            backgroundColor: theme.palette.secondary.light,
            borderLeft: `6px solid ${theme.palette.primary.main}`,
            p: { xs: 2, sm: 3 },
            borderRadius: 2,
            mb: 4,
          }}
        >
          <Typography fontWeight={600}>
            Inscriptions en ligne ouvertes jusqu'au 27 juin 2025 !
          </Typography>
          <Typography variant="body2">
            Passé cette date, un supplément de 2€ par tableau sera appliqué.
          </Typography>
        </Box>

        <Typography paragraph>
          Rejoignez le plus grand tournoi de tennis de table de la région sur 36
          tables, avec une buvette sur place et des récompenses allant jusqu'à{" "}
          <strong>300€</strong> pour les vainqueurs.
        </Typography>

        <Typography paragraph>
          Tous les niveaux sont les bienvenus, du loisir aux compétiteurs
          aguerris. Consultez les tableaux pour connaître les horaires et les
          places restantes.
        </Typography>

        <Box
          sx={{
            my: 4,
            px: 3,
            py: 2,
            borderRadius: 2,
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.text.primary,
            textAlign: "center",
            boxShadow: 2,
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            🎯 Ne tardez pas ! Plus que quelques places…
          </Typography>
          <Typography variant="body2">
            Assurez-vous une place dans vos tableaux favoris dès maintenant.
          </Typography>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Box
            sx={{
              mt: { xs: 4, md: 8 },
              p: { xs: 2, sm: 3 },
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              backgroundColor: theme.palette.background.paper,
              // mb: { xs: 4, sm: 6 },
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Tarifs
            </Typography>
            <ul style={{ marginTop: 0 }}>
              <li>1 tableau : 9€</li>
              <li>2 tableaux : 16€</li>
              <li>* Sauf tableau P (+2€)</li>
            </ul>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Les tarifs indiqués sont valables pour une journée. En cas de
              participation aux deux journées, les frais se cumulent. Par
              exemple : 3 tableaux = 25€, 4 tableaux = 32€.
            </Typography>
          </Box>
        </Box>
      </Box>
    </BackgroundWrapper>
  );
};

export default Home;
